<footer class="footer" [dir]="lang.getDir()">
  <div class="footer-container">

    <!-- Left side: Logo & Name -->
    <div class="footer-brand">
      <img src="assets/logo.png" alt="Andlossia Logo" class="footer-logo" />
      <span class="brand-name">{{ 'site.name' | translate }}</span>
    </div>

    <!-- Middle: Navigation Links -->
    <div class="footer-links">
      <a href="#" class="footer-link">{{ 'footer.home' | translate }}</a>
      <a href="#" class="footer-link">{{ 'footer.about' | translate }}</a>
      <a href="#" class="footer-link">{{ 'footer.projects' | translate }}</a>
      <a href="#" class="footer-link">{{ 'footer.contact' | translate }}</a>
    </div>

    <!-- Right side: Language & Theme Controls -->
    <div class="footer-controls">
      <!-- Language Dropdown -->
      <div class="dropdown">
        <button class="dropdown-button" (click)="toggleLangMenu()">
          <img [src]="getFlagUrl(currentLang)" width="20" height="14" />
          {{ getLangLabel(currentLang) }} ⏷
        </button>
        <ul class="dropdown-list" *ngIf="showLangMenu">
          <li *ngFor="let lang of langs" (click)="changeLang(lang.code)">
            <img [src]="getFlagUrl(lang.code)" width="20" height="14" />
            {{ lang.label }}
          </li>
        </ul>
      </div>

      <!-- Theme Dropdown -->
      <div class="dropdown">
        <button class="dropdown-button" (click)="toggleThemeMenu()">
         {{ getThemeIcon(themePreference()) }} {{ getThemeLabel(themePreference()) }} ⏷
        </button>
        <ul class="dropdown-list" *ngIf="showThemeMenu">
          <li *ngFor="let theme of themes" (click)="changeTheme(theme.code)">
            {{ theme.icon }} {{ theme.label }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Bottom Copy -->
  <div class="footer-bottom">
    <span>&copy; {{ currentYear }} {{ 'site.name' | translate }}. {{ 'footer.rights' | translate }}</span>
  </div>
</footer>
